import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { UtilServico } from 'src/app/servicos/util.servico';
import { UtilDadosLogado } from 'src/app/servicos/util.logado';
import { Router } from '@angular/router';
import { UploadService } from 'src/app/upload/upload.service';
import { HttpEventType, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import swal from 'sweetalert2';
import { ConnectedPositionStrategy } from '@angular/cdk/overlay';

@Component({
  selector: 'app-s100',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './s100.component.html',
  styleUrls: ['./s100.component.scss']
})
export class S100Component implements OnInit {
  Form: FormGroup;
  dados: any = {};

  validacao_mensagens = {
    tipo: [{ type: 'required', message: 'Tipo é requerido' }]
  };
  Carregando: boolean;
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<S100Component>,
    private utilServico: UtilServico,
    private utilDadosLogado: UtilDadosLogado,
    private router: Router,
    private uploadService: UploadService
  ) {
    this.Form = fb.group({
      tipo: [null, Validators.required],
      iniValid: null,
      fimValid: null
    });
  }

  ngOnInit() {
    const { usuario_id, db_config } = this.utilDadosLogado.DadosAcesso();

    console.log(db_config.ambiente_esocial);
    this.dados.tipo = 'I';
    this.dados.iniValid = '07/2021';
    this.dados.ambiente_esocial = db_config.ambiente_esocial;
    this.dados.fimValid =
      (new Date().getMonth() + 1).toString().length < 2
        ? '0' + (new Date().getMonth() + 1).toString() + '/' + new Date().getFullYear().toString()
        : (new Date().getMonth() + 1).toString() + '/' + new Date().getFullYear().toString();
  }

  Salvar(): void {
    //if (this.Form.valid) {
    const { usuario_id, db_config } = this.utilDadosLogado.DadosAcesso();
    this.utilServico
      .Post(
        //'Empregador/S1000',
        //'EstabelecimentoObrasUnidades/S1005',
        'TabelaRubrica/S1000',
        //'TabelaCargosEmpregosPublicos/S1030',
        {
          tipo_xml: this.dados.tipo,
          usuario_id,
          db_config,
          iniValid: this.dados.iniValid,
          fimValid: this.dados.fimValid
        },
        true
      )
      .subscribe(
        data => {
          console.log(this.utilDadosLogado.DadosAcesso().url);
          var event = document.createEvent('CustomEvent');
          event.initCustomEvent('EnviarDadosString', true, true, {
            metodo: 'ExEsocial',
            xml: data.xml,
            ambiente: data.Ambiente,
            retaguarda: data.Retaguarda,
            ws: this.utilDadosLogado.DadosAcesso().url,
            tipoenvio: 'N'
          });
          document.documentElement.dispatchEvent(event);
          this.dialogRef.close();
          this.router.navigate(['/principal/individual']);
        },
        error => {
          console.log(error._body);
          swal.fire({
            title: 'Atenção!',
            type: 'error',
            text:
              'Algo deu errado! Verifique os parâmetros gerais para envio correto do registro. Se o erro persistir, entre em contato com o suporte interno.'
          });
        }
      );
    //}
  }

  handleFileInput(files: FileList, row) {
    const DadosAcesso = this.utilDadosLogado.DadosAcesso();
    console.log(row);
    const fileToUpload = files.item(0);
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    formData.append('SeguradoId', "0");
    formData.append('Tipo', '1000');
    this.uploadService.Upload('Retaguarda/Upload', formData).subscribe(
      event => {
        // if (event.type === HttpEventType.UploadProgress) {
        //   //const percentDone = Math.round((100 * event.loaded) / event.total);
        //   swal.fire({
        //     title: 'Atenção!',
        //     text: 'Documento sendo importado, aguarde.',
        //     onBeforeOpen: () => {
        //       swal.showLoading();
        //     }
        //   });
        // } else if (event instanceof HttpResponse) {
        //   swal.fire({
        //     title: 'Atenção!',
        //     type: 'success',
        //     text: 'Documento importado com sucesso, agora ele será processando e você será notificando quando eu terminar.'
        //   });
        //   this.CarregarProcessado(null);
        // }

        if (event.type === HttpEventType.UploadProgress) {
          swal
            .fire({
              title: 'Atenção!',
              text: 'Xml enviado com sucesso, agora ele será processando pelo esocial e você será notificando quando terminar!',
              type: 'success',
              showCancelButton: false
            })
            .then(result => {
              if (result.value) {
                this.Enviarxml("I");
              }
            });
        }
      },
      error => {
        this.Carregando = false;
      }
    );
  }

  Enviarxml(item): void {
    const { usuario_id, db_config } = this.utilDadosLogado.DadosAcesso();
    this.utilServico
      .Post(
        'TabelaRubrica/S1000Xml',
        {
          tipo_xml: 'I',
          usuario_id,
          db_config,
          segurado_id: 0
        },
        true
      )
      .subscribe(
        data => {
          console.log(data.xml);
          var event = document.createEvent('CustomEvent');
          event.initCustomEvent('EnviarDadosString', true, true, {
            metodo: 'ExEsocial',
            xml: data.xml,
            ambiente: data.Ambiente,
            retaguarda: data.Retaguarda,
            ws: this.utilDadosLogado.DadosAcesso().url,
            tipoenvio: 'N'
          });
          document.documentElement.dispatchEvent(event);
          this.dialogRef.close();
          this.router.navigate(['/principal/individual']);
        },
        error => {
          swal.fire({
            title: 'Atenção!',
            type: 'error',
            text: 'Favor preencher o formulário antes de realizar o envio.'
          });
        }
      );
  }
}
